module.exports = __webpack_public_path__ + "media/images/flags/tj-7904c4ced6faaeac36f86734f0c456e8.svg";